// import { DataSource } from 'ng2-smart-table/lib/lib/data-source/data-source';
import { Observable } from 'rxjs';
import { has, isNil, isObject, isString, find, isEmpty,  } from 'lodash';

import { DataSource, ServerDataSource } from 'angular2-smart-table';
// import { ViewCell } from 'ng2-smart-table';
import { Model } from './common/.base.model';
import { Person } from './person';
import { DatePipe } from '@angular/common';
import { User } from './auth/users';
import { EntityConfigTemplate } from './common/entity-config.interface';

const dPipe = new DatePipe('en-US');

export interface OKR extends Model {
  person?: Person | string;
  objective?: string;
  keyResults?: string;
  startDate?: Date;
  endDate?: Date;
  okrStatus?: string;
}

export interface Appraisal extends Model {
  person?: Person;
  summary?: string;
  rating?: number;
  date?: Date;
  reviewer?: string | Person;
  file?: any;
}

export const OKRConfig: EntityConfigTemplate = {
  meta: { entityName: 'OKR', entityPluralName: 'OKRs', titleField: 'objective', view: false, attachedToField: 'person' },
  objective: { title: 'Objective' },
  keyResults: { title: 'Key Results' },
  person: { isForeignKey: true, view: false, title: 'Person', valuePrep: (_cell_, row) => `${row?.person?.firstName} ${row?.person?.lastName}` },
  startDate: { title: 'Start Date', type: 'date', valuePrep: (cell: Date, _: any) => dPipe.transform(cell, 'MMM dd, yyyy'), },
  endDate: { title: 'End Date', type: 'date', valuePrep: (cell: Date, _: any) => dPipe.transform(cell, 'MMM dd, yyyy'), },
  okrStatus: { title: 'Status' },
};

export const AppraisalConfig: EntityConfigTemplate = {
  meta: { entityName: 'appraisal', entityPluralName: 'appraisals', titleField: 'person', view: false, attachedToField: 'person' },
  person: { isForeignKey: true, view: false, type: 'relation', title: 'Person', valuePrep: (_cell_, row) => `${row?.person?.firstName ?? ''} ${row?.person?.lastName ?? ''}` },
  summary: { title: 'Summary' },
  rating: { title: 'Rating (1-5)', type: 'number' },
  reviewer: { isForeignKey: true, type: 'relation', title: 'Reviewer', valuePrep: (_cell_, row) => `${row?.reviewer?.firstName ?? ''} ${row?.reviewer?.lastName ?? ''}`, default: "-" },
  date: { title: 'Completed At', type: 'date', valuePrep: (cell: Date, _: any) => dPipe.transform(cell, 'MMM dd, yyyy'), },
  file: { title: 'File', type: 'file' },
};

export abstract class OKRData {
  abstract get gridDataSource(): ServerDataSource;
  abstract list(pageNumber: number, pageSize: number): Observable<OKR[]>;
  abstract listAll(): Observable<OKR[]>;
  abstract get(id: string): Observable<OKR>;
  abstract update(record: OKR): Observable<OKR>;
  abstract create(record: OKR): Observable<OKR>;
  abstract delete(id: string): Observable<boolean>;
}

export abstract class AppraisalData {
  abstract get gridDataSource(): ServerDataSource;
  abstract list(pageNumber: number, pageSize: number): Observable<Appraisal[]>;
  abstract listAll(): Observable<Appraisal[]>;
  abstract get(id: string): Observable<Appraisal>;
  abstract update(Department: Appraisal): Observable<Appraisal>;
  abstract create(Department: Appraisal): Observable<Appraisal>;
  abstract delete(id: string): Observable<boolean>;
}